import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

export interface ThemeProps {
  mode: 'dark' | 'light' | undefined;
}

// Define the initial state using that type
const initialState: ThemeProps = {
  mode: 'dark',
};

export const themeSlice = createSlice({
  name: 'theme',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'dark' ? 'light' : 'dark';
    },
  },
});

export const { toggleTheme } = themeSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectTheme = (state: RootState) => state.theme.mode;

export default themeSlice.reducer;
